import { Suspense, useEffect } from 'react';
import { Layout } from 'antd';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useLoading } from './LoadingContext';
import { useTranslation } from 'react-i18next';
import useWindowSize from '../../hooks/useWindowSize';
import OutsideLayoutHeader from './OutsideLayoutHeader';
import OutsideLayoutRightCard from './OutsideLayoutRightCard';
import MyFlexCenter from '../../components/myFlex/MyFlexCenter';
import './OutsideLayout.scss';

const { Content } = Layout;

const OutsideLayout = ({ children, isCenter }) => {
  const { lang } = useParams();
  const { loading } = useLoading();
  const { i18n } = useTranslation();
  const { isMobile } = useWindowSize();

  const langRedux = useSelector((state) => {
    return state.lang;
  });

  useEffect(() => {
    if (lang !== langRedux) {
      i18n.changeLanguage(lang);
    }
  }, [lang, langRedux, i18n]);

  return (
    <Layout className="outside_layout">
      <Content className="outside_layout_content">
        <div
          className={`outside_layout_left_child ${
            isMobile || loading ? 'full_width' : 'half_width'
          }`}
        >
          {loading ? null : <OutsideLayoutHeader />}
          <MyFlexCenter style={isCenter ? { flex: 1 } : undefined}>
            <Suspense fallback={null}>{children}</Suspense>
          </MyFlexCenter>
        </div>
        {isMobile || loading ? null : <OutsideLayoutRightCard />}
      </Content>
    </Layout>
  );
};

export default OutsideLayout;
